module.exports = __webpack_public_path__ + "img/team-set.84347944.svg";